import { createContext } from 'react';
export const IconContext = createContext({});
